import React from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import { contact } from '../data/mock';

export default function CookiesPolicyPage() {
  return (
    <>
      <SEO
        title="Cookies Policy"
        description="How Salihi Consulting Services uses cookies and similar tracking technologies on this website."
        path="/cookies-policy"
      />
      <PageHero
        breadcrumb="Cookies Policy"
        eyebrow="Legal"
        title="Cookies"
        italicTitle="Policy."
        subtitle="This Cookies Policy explains how Salihi Consulting Services uses cookies and similar tracking technologies when you visit our website."
      />

      <section className="py-16 sm:py-20 bg-[#0d2143]">
        <div className="max-w-[900px] mx-auto px-5 sm:px-6 lg:px-10">
          <article className="prose-policy">
            <Block title="1. What are cookies?">
              Cookies are small text files placed on your device (computer, tablet or
              mobile) when you visit a website. They allow the site to recognize your
              device, remember your preferences, and improve your overall experience.
              Cookies do not give us access to your device or to any information about
              you beyond what you choose to share.
            </Block>
            <Block title="2. How we use cookies">
              We use cookies to operate our website reliably, understand how visitors
              interact with our content, remember your preferences, and continuously
              improve the quality of our digital presence. We do not use cookies to
              collect personally identifying information without your knowledge.
            </Block>
            <Block title="3. Categories of cookies we use">
              <List items={[
                { label: 'Strictly necessary cookies', desc: 'These are essential for the website to function. They enable basic features such as page navigation, security, accessibility, and form submission. The site cannot function properly without them, and they cannot be switched off.' },
                { label: 'Analytics cookies', desc: 'These help us understand which pages are useful, how visitors move through the site, and where we can improve. The information collected is aggregated and anonymous.' },
                { label: 'Preference cookies', desc: 'These remember choices you make — such as language, region or theme — so the site feels familiar and personalized on your next visit.' },
                { label: 'Third-party cookies', desc: 'In limited cases, cookies set by trusted third-party services (for example, embedded maps or video providers) may be loaded when you interact with that content.' },
              ]} />
            </Block>
            <Block title="4. Managing your cookie preferences">
              When you first visit our site you are presented with a cookie banner that
              allows you to accept all cookies, reject all non-essential cookies, or
              manage each category individually. You can change your decision at any
              time by clicking the “Cookies Policy” link in the footer of this site.
              You can also clear or block cookies directly through your browser
              settings; please note that disabling certain cookies may affect site
              functionality.
            </Block>
            <Block title="5. Retention">
              Session cookies are deleted when you close your browser. Persistent
              cookies remain on your device for a defined period or until you delete
              them. Where we are required to retain cookie-related records for
              compliance purposes, we do so for the minimum period necessary.
            </Block>
            <Block title="6. Updates to this policy">
              We may update this Cookies Policy from time to time to reflect operational,
              legal or regulatory changes. Any updates will be posted on this page with
              a revised effective date.
            </Block>
            <Block title="7. Contact us">
              For any questions about how we use cookies, please contact us at{' '}
              <a href={`mailto:${contact.email}`} className="text-[#e8b863] underline underline-offset-2">
                {contact.email}
              </a>
              .
            </Block>
          </article>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-serif text-white font-medium text-[22px] sm:text-[26px] leading-tight tracking-tight mb-4">
        {title}
      </h2>
      <div className="text-white/78 text-[15px] leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

function List({ items }) {
  return (
    <ul className="space-y-3">
      {items.map((it) => (
        <li key={it.label} className="bg-gradient-to-br from-white/[0.05] to-white/[0.02] border border-white/10 rounded-2xl p-5">
          <p className="text-[#e8b863] font-semibold text-[14.5px] mb-1.5">{it.label}</p>
          <p className="text-white/75 text-[14px] leading-relaxed">{it.desc}</p>
        </li>
      ))}
    </ul>
  );
}
